import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../../../core/services/notification/notification.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TransactionResult } from '../../../../../core/services/interfaces/transaction-result';
import { IBuildings } from '../../Interfaces/IBuildings';
import { ISites } from '../../Interfaces/ISites';
import { SitesService } from '../../services/sites-services';
import { BuildingsService } from '../../services/buildings-services';
import { TranslateApplicationService } from '../../../../../core/translate/translate-application-service';

@Component({
	selector: 'building-detail',
	templateUrl: 'building-detail.component.html'
})

export class BuildingDetailComponent {
	formGroup: FormGroup;
	loading = false;
	listSites: Array<ISites> = [];
  	max_characters: string = "";
	constructor(
		private dialogRef: MatDialogRef<BuildingDetailComponent>,
		@Inject(MAT_DIALOG_DATA) public data: IBuildings,
		private notificationService: NotificationService,
		private siteService: SitesService,
		private buildingService: BuildingsService,
		private formBuilder: FormBuilder,
		public translate: TranslateApplicationService,
	) {
		this.formGroup = this.formBuilder.group({
			pkbuilding: [data.pkbuilding == null ? 0 : data.pkbuilding],
      		txtbuilding: [
				data.building,
				[
					Validators.required,
					Validators.maxLength(255),
					Validators.pattern('.*[a-zA-Z].*')
				]
			],
			txtaddress: [
				data.address,
				[
					Validators.required,
					Validators.maxLength(255),
					Validators.pattern('.*[a-zA-Z].*')
				]
			],
			txtcity: [
				data.city,
				[
					Validators.required,
					Validators.maxLength(255),
					Validators.pattern('.*[a-zA-Z].*')
				]
			],
			txtstate: [
				data.state,
				[
					Validators.required,
					Validators.maxLength(255),
					Validators.pattern('.*[a-zA-Z].*')
				]
	  		],
	  		txtpostalcode: [
				data.postal_code,
				[
					Validators.required,
					Validators.maxLength(255),
					Validators.pattern('.*[0-9a-zA-Z].*')
				]
	  		],
	  		available: data.available
		});
    	this.GetSites();
  	}
  
  	ngOnInit(): void {
    	let max_char = this.translate.TranslateKey('max_characteres');
		this.max_characters = max_char.replace('{{ number_max }}', '255');
  	}

	GetSites() {
		this.loading = true;
		this.siteService.GetList().subscribe(
      	(result1: TransactionResult<ISites[]>) => {
        	if (result1.success) {
				this.loading = false;
          		result1.data.forEach((obj) => {
            		if (obj.available == true)
              			this.listSites.push(obj);
          		});
        	}
			else{
				this.loading = false;
				this.ErrorAlert(result1.message);
			}
      	},
      	(error: any) => { 
			this.ErrorAlert(error); this.loading = false; 
		});
	}

	//button save for add/edit
	Save() {
		this.loading = true;
		if (this.formGroup.valid) {
			this.loading = true;
			if (this.formGroup.controls.pkbuilding.value == 0) {
				this.buildingService.CreateBuilding(this.formGroup.value).subscribe(
				(result: TransactionResult<boolean>) => {
					this.loading = false;
					if (result.success) {
						this.Alert();
						this.dialogRef.close(true);
					}
				},
				(error: any) => { 
					this.ErrorAlert(error); this.loading = false; 
				});
			} 
			else {
				this.formGroup.controls.available.setValue(this.data.available);
				this.buildingService.UpdateBuilding(this.formGroup.value).subscribe(
				(result: TransactionResult<boolean>) => {
					this.loading = false;
					if (result.data) {
						this.Alert();
						this.dialogRef.close(true);
					}
				},
				(error: any) => { 
					this.ErrorAlert(error); this.loading = false; 
				});
			}
		} 
		else {
			this.loading = false;
			this.notificationService.AddAlert({
				icon: 'all_inbox',
				title: 'Warning',
				message: this.translate.TranslateKey('COMPLETE_FORM'),
				shown: true,
			});
		}
	}

	Close() {
		this.dialogRef.close(false);
	}

	Alert() {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Success',
			message: this.translate.TranslateKey('COMPLETE'),
			shown: true,
		});
	}
	
	ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
    }
}
